module.exports = __webpack_public_path__ + "static/media/subtract.a8d9822d.svg";